import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=2242f419&"
import script from "./SearchDialog.vue?vue&type=script&lang=js&"
export * from "./SearchDialog.vue?vue&type=script&lang=js&"
import style0 from "./SearchDialog.vue?vue&type=style&index=0&id=2242f419&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports